<template>
  <div class="transfer-items-information">
    <div class="transfer-items-content">
      <div>
        <img :src="transferIcon" id="transferIcon" />
      </div>
      <content>
        <div class="transfer-title" id="transfer-title" v-html="tdc.tdc_transferItemsTitle"></div>
        <div class="transfer-information" id="transfer-information" v-html="tdc.tdc_transferItemsMessage"></div>
      </content>
    </div>
  </div>
</template>
<script>

import config from '../js/qualificationsConfigService'

export default {
  data() {
    return {
      tdc: config.getTdc(),
      transferIcon: require('../assets/transfer_icon.png'),
    }
  },
  name: 'TransferItemsInformation',
  props: {
    qualifications: Object,
    product: Object,
  },
}

</script>
<style lang="scss" scoped>
  @import '~@nuskin/ns-core-styles/src/scss/global.mixins';
  @import '~@nuskin/ns-core-styles/src/scss/vuetifyOverrides';
  .transfer-items-content {
    width: 330px;
    text-align: center;
    margin: auto 40px;
    font-family: var(--font-family-primary);
    line-height: 18px;
  }
  .transfer-title {
    font-size: 20px;
    font-weight: 600;
    margin-top: 15px;
    text-align: center;
    color: black;
  }
  .transfer-information {
    margin: 10px;
    text-align: center;
  }
  .transfer-notice {
    margin-top: 2em;
    text-align: center;
  }
</style>
